import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DocumentFieldOption, FieldSchema } from '@lsq-frontend/remote-services/ar-app';

@Component({
    selector: 'dr-schedule-document-request',
    templateUrl: './dr-schedule-document-request.component.html',
    styleUrls: ['./dr-schedule-document-request.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ScheduleDocumentRequest {
    @Input() formGroup: FormGroup;
    @Input() fieldSchema: FieldSchema;

    public show: boolean;

    public ngOnInit(): void {
        const fieldOption = this.fieldSchema?.fieldOption as DocumentFieldOption;
        this.show = fieldOption?.scheduleRequest;
    }

    toggle() {
        this.show = !this.show;
    }
}
